import { type Listing } from '@/features/listing/types/listing-types';
import { getUserBearerCookie } from '@/features/user/cookies/cookie-user-bearer';
import sendHttpError from '@/libs/logger/requests/send-http-error';

export default async function createListingBookmark(
  listingId: Listing['id'],
  listingTypeId: number,
): Promise<void> {
  const url = `${process.env.NEXT_PUBLIC_API_URL}/v1/bookmarks`;
  const bearerToken = getUserBearerCookie();

  const headers: HeadersInit = { 'Content-Type': 'application/json' };

  if (bearerToken) {
    headers.Authorization = `Bearer ${bearerToken}`;
  }

  const bookmarkBody = {
    bookmark_type: 'Bookmarked',
    listing_id: listingId,
    service_type: listingTypeId,
  };

  const createListingBookmarkResponse = await fetch(url, {
    body: JSON.stringify(bookmarkBody),
    cache: 'no-store',
    headers,
    method: 'POST',
  });

  if (!createListingBookmarkResponse.ok) {
    sendHttpError({
      baseName: 'Create Listing Bookmark',
      body: bookmarkBody,
      functionName: 'createListingBookmark',
      method: 'POST',
      requestHeaders: headers,
      statusCode: createListingBookmarkResponse.status,
      url,
    });
  }
}
